/* eslint-disable react/jsx-no-undef */
import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import Icon from "@material-ui/core/Icon";

// @material-ui/icons
// import ContentCopy from "@material-ui/icons/ContentCopy";
// import InfoOutline from "@material-ui/icons/InfoOutline";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import axios from "../../utils/axiosInstance";

import CardFooter from "components/Card/CardFooter.js";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import {
  AccountBalanceOutlined,
  CasinoOutlined,
  EmailOutlined,
  LocalActivityOutlined,
  LocalAtmOutlined,
  MonetizationOnOutlined,
  PeopleOutline,
  PersonOutline,
} from "@material-ui/icons";
const useStyles = makeStyles(styles);
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from "@material-ui/core";

export default function Dashboard() {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(true);
  const [dataValue, setDataValue] = React.useState([]);
  const navigate = useNavigate();

  React.useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      setLoading(true);
      try {
        await axios
          .get(
            `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/dashboardUserCount`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Access-Control-Allow-Origin": "*",
              },
            }
          )
          .then((res) => {
            const data = res.data;
            setDataValue(data);
            console.log(data);
          });
      } catch (error) {
        console.error(error.message);
        if (error?.response?.data?.message == "For security reasons, we locked your account.Please login to continue") {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
        // localStorage.removeItem("token");
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <GridContainer>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="warning" stats icon style={{ cursor: 'pointer' }} onClick={() => navigate("/admin/userManagement")}>
                <CardIcon color="warning">
                  <PeopleOutline />
                </CardIcon>
                <p className={classes.cardCategory}>Total Player</p>
                <h3 className={classes.cardTitle}>
                  {dataValue?.userDashboardCount?.[0]?.playerCount}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Danger>
                    <Warning />
                  </Danger>
                  <a href="#pablo" onClick={(e) => e.preventDefault()}>
                    Get more space
                  </a>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="success" stats icon style={{ cursor: 'pointer' }} onClick={() =>
                navigate("/admin/userManagement", {
                  state: { isActive: true }
                })
              }>
                <CardIcon color="success">
                  <PersonOutline />
                </CardIcon>
                <p className={classes.cardCategory}>Active Player</p>
                <h3 className={classes.cardTitle}>
                  {" "}
                  {dataValue?.userDashboardCount?.[0]?.activeUserCount}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <DateRange />
                  Last 1 Hour
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="danger" stats icon style={{ cursor: 'pointer' }} onClick={() => navigate("/admin/ManageLotteries")}>
                <CardIcon color="danger">
                  <CasinoOutlined />
                </CardIcon>
                <p className={classes.cardCategory}>Open Lotteries</p>
                <h3 className={classes.cardTitle}>
                  {dataValue?.ongoingLotteryCount}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <LocalOffer />
                  Tracked from Github
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="primary" stats icon style={{ cursor: 'pointer' }} onClick={() => navigate("/admin/ManageWithdraw")}>
                <CardIcon color="primary">
                  <AccountBalanceOutlined />
                </CardIcon>
                <p className={classes.cardCategory}>Total Deposited</p>
                <h3 className={classes.cardTitle}>
                  {" "}
                  {dataValue?.paymentDashboardCount?.[0]?.totalDepositAmount.toLocaleString()}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <LocalOffer />
                  Tracked from Github
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="info" stats icon style={{ cursor: 'pointer' }} onClick={() => navigate("/admin/ManageWithdraw")}>
                <CardIcon color="info">
                  <AccountBalanceOutlined />
                </CardIcon>
                <p className={classes.cardCategory}>Total Withdraw</p>
                <h3 className={classes.cardTitle}>
                  {dataValue?.paymentDashboardCount?.[0]?.totalWithdrawAmount.toLocaleString()}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <LocalOffer />
                  Tracked from Github
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="danger" stats icon style={{ cursor: 'pointer' }} onClick={() => navigate("/admin/ManageWithdraw")}>
                <CardIcon color="danger">
                  <Update />
                </CardIcon>
                <p className={classes.cardCategory}>Pending Withdraw</p>
                <h3 className={classes.cardTitle}>
                  {
                    dataValue?.paymentDashboardCount?.[0]
                      ?.totalPendingWithdrawAmount.toLocaleString()
                  }
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <LocalOffer />
                  Tracked from Github
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="rose" stats icon style={{ cursor: 'pointer' }} onClick={() => navigate("/admin/report-management/soldTicketLogs")}>
                <CardIcon color="rose">
                  <LocalActivityOutlined />
                </CardIcon>
                <p className={classes.cardCategory}>Sold Tickets</p>
                <h3 className={classes.cardTitle}>
                  {dataValue?.soldTicketCount?.[0]?.totalSoldLottery.toLocaleString()}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <LocalOffer />
                  Tracked from Github
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="warning" stats icon style={{ cursor: 'pointer' }} onClick={() => navigate("/admin/report-management/soldTicketLogs")}>
                <CardIcon color="warning">
                  <LocalAtmOutlined />
                </CardIcon>
                <p className={classes.cardCategory}>Sold Amount</p>
                <h3 className={classes.cardTitle}>
                  {dataValue?.soldTicketCount?.[0]?.soldTicketAmount.toLocaleString()}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <LocalOffer />
                  Tracked from Github
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="danger" stats icon style={{ cursor: 'pointer' }} onClick={() => navigate("/admin/report-management/WinnerLogs")}>
                <CardIcon color="danger">
                  <Icon>info_outline</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Winners</p>
                <h3 className={classes.cardTitle}>
                  {dataValue?.winnerCount?.[0]?.totalWinnerCount}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <LocalOffer />
                  Tracked from Github
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="info" stats icon style={{ cursor: 'pointer' }} onClick={() => navigate("/admin/report-management/WinnerLogs")}>
                <CardIcon color="info">
                  <MonetizationOnOutlined />
                </CardIcon>
                <p className={classes.cardCategory}>Win Amounts</p>
                <h3 className={classes.cardTitle}>
                  {" "}
                  {dataValue?.winnerCount?.[0]?.winnerAmountCount.toLocaleString()}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Update />
                  Just Updated
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      )}
    </div>
  );
}
